import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination, Autoplay } from "swiper";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import "swiper/swiper-bundle.css";

import "./ClientSwiper.css";
SwiperCore.use([Navigation, Pagination, Autoplay]);
const ClientSwiper = () => {
    const customPrevButton = (
        <IoIosArrowBack size={30} color="#333" className="swiper-button-prev" />
    );

    const customNextButton = (
        <IoIosArrowForward size={30} color="#333" className="swiper-button-next" />
    );

    return (
        <Swiper
            navigation={{
                prevEl: ".swiper-button-prev",
                nextEl: ".swiper-button-next",
            }}
            pagination={{ clickable: true }}
            loop
            speed={1000}
            autoplay={{ delay: 1000 }} // Set autoplay delay to 1 second
            className="swiper2 p-8 my-4"
        >
            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-sm md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
                    "    חייבת להמליץ. קוסמטיקאית עדינה. מקצועיות ללא

                    פשרות. טיפול מפנק. זה המקום לקבל את הטיפול
                    המושלם."

                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    רחל ר
                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-xs md:text-base mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>

                    "          מאחורי כל הכישרון והדיוק המדהים להפליא. עומדת
                    בחורה כל כך מקסימה וחמה שמהרגע שניכנס אין דבר
                    שיהיה לה חשוב יותר מאשר שנזכה להינות מחוויה
                    טיפולית מפנקת, ומתוצאה שתשאיר אותנו בעננים. אני
                    אישית חוזרת כל פעם לקבל את התוצאות שאני כל כך

                    אוהבת, ממליצה בחום רב ❤️."
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>

                    עומר ר                </p>
            </SwiperSlide>

            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-xs md:text-base mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>

                    "      קודם כל לפני כל העבודה שהיא עשתה שיצאה
                    מושלם!!! חשוב לי לציין שיש לה ידיים זהב!!! המגע שלה
                    עדין ונעים והיא מקצועית ברמות. אני עוסקת גם בתחום
                    היופי ומי כמוכן יודעת כמה קשה לבחור ידיים טובות-₪.
                    אני אישית ממש ממש מרוצה . וחזרתי אליה כבר 6
                    פעמים ותמיד היא נותנת לי הרגשה חדשה כאילו יצאתי
                    מניתוח יופי חהחחחח. ענאל עשתה לי הדבקת ריסים.
                    והרמת גבות פשוט הצגה התמונה לפניכן."
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    בתאל א
                </p>
            </SwiperSlide>

       


            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-xs md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>

"כל פעם שאני יוצאת מאנאל אני יוצאת הילה חדשה, היא היחידה שאני מרשה לה לגעת לי בגבות ❤️"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
הילה ר
                </p>
            </SwiperSlide>


            <SwiperSlide>
                {/* <img src="https://images.pexels.com/photos/3785417/pexels-photo-3785417.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="client_photo" style={{ width: '80px', height: '80px' }} className='rounded-full mx-auto' /> */}
                <p className='px-12 mt-6 text-xs md:text-lg mx-auto rtl font-medium max-w-[400px] lg:max-w-[600px] text-main' dir='rtl'>
"אנאל עובדת נקי מאוד, מקצועית, תוצאה מושלמת ומדוייקת והשירות שלה מספר 1, מחכה לתור הבא שלי כבר ❤️❤️"
                </p>
                <p className='text-sm mx-auto rtl font-bold text-clientName mt-2' dir='rtl'>
                    יובל ר
                </p>
            </SwiperSlide>




            <div className="swiper-button-prev-custom">{customPrevButton}</div>
            <div className="swiper-button-next-custom">{customNextButton}</div>
        </Swiper>
    );
}

export default ClientSwiper